import {
  ACCESS_MANAGER,
  ACCESS_MANAGER_REQUEST,
  MANAGE_USERS,
  ORGANIZATIONS,
  VIEW_CONFIGURATION_TOOL,
  WRITE_CONFIGURATION_TOOL,
  WRITE_VALUE_CONFIGURATION_TOOL,
  TEMPLATE_EDITOR,
  INTERNAL_TOOLS,
  ACTIVATE_SCHOOLS,
  CREATE_ORGANIZATION,
  PLATFORM_ACCESS_MANAGER,
  TOOLS,
  VIEW_CONFIGURATIONS,
  STUDENT,
  STAFF,
  PARENT,
  ROLE_VISITOR,
  DELETE_ORGANIZATION,
  GRAPHQL_PLAYGROUND,
  SWITCH_SCHOOL_USERNAME,
  INTERNAL_PORTAL,
  INTERNAL_PORTAL_ACCESS,
  ALLOW_ELASTICACHE_MANAGEMENT,
  ELASTICACHE_FLUSHDB_ALLOWED_IDENTITIES,
  ALLOW_ELASTICACHE_AUDIT_LOG_VIEWING,
} from "./stringConstants";

/** SNPv2 Feature Permissions */
export const SNPv2_PERM = "Common:SnpV2";
export const SNPv2_TEACHER_MODULE_PERM = "TeacherPortal:SnpV2";
export const SNPv2_VISITOR_MODULE_PERM = "VisitorPortal:SnpV2";

export const SNPv2_VISITOR_PORTAL_PERM_GROUP = "VisitorPortal";
export const ENABLE_AUTH_AND_EVAL_REVAMP =
  "FeatureFlag:EnableAuthAndEvalRevamp";

export const SNP_SELECTED_PROGRAMS_FOR_CCH = "SnPSelectedProgramsForCCH";

export const SCHOOL_POLICIES_SELECTED_PROGRAMS_FOR_CCH =
  "SchoolPoliciesProgramsCCHMobile";

export const LEARNING_COURSE_FILTER_IN_SNP =
  "FeatureFlag:LearningCourseFilterInSnP";

export const PROGRAMME_WIDE_CONFIGURATIONS_ACCESS_PERMISSION =
  "Module:ProgrammeAdminPortal";

export const ADMIN_PORTAL_ACCESS_PERMISSION = "Module:AdminPortal";

export const SCHOOL_OVERVIEW_ACCESS_PERMISSION = "Module:SchoolOverview";

export const SCHOOL_ROSTER_ACCESS_PERMISSION = "Module:SchoolRoster";

export const SCHOOL_ROSTER_ACCESS_PERMISSION_FOR_ACCOUNT =
  "Module:SchoolRosterForAccount";

export const SCHOOL_WIDE_SETTINGS_ACCESS_PERMISSION = "Module:Settings";

export const SNPv2_ACCESS_PERMISSION = "Module:AuthorisationAndEvaluation";

export const MODULE_SETTINGS_ACCESS_PERMISSION = "Module:ModuleSettings";
export const ENABLE_MODULE_SETTINGS_IN_PROGRAMME_WIDE_CONFIGURATIONS =
  "FeatureFlag:EnableModuleSettingsInProgrammeWideConfigurations";

export const MODULE_SETTINGS_V2 = "FeatureFlag:ModuleSettingsV2";

export const ACADEMY_ANALYTICS_ACCESS_PERMISSION = "Module:AcademyAnalytics";

export const SNPv2_MANAGE_EVALUATION_CYCLES_PERMISSION =
  "AuthorisationAndEvaluation:CanManageEvaluationCycles";

export const CAS_SUPERVISORS_VIEW_AND_MANAGE_PERMISSION =
  "Module:CasSupervisors";

export const VISITORS_VIEW_AND_MANAGE_PERMISSION = "Module:Visitors";

export const ENABLE_SNP_EVIDENCE_DOWNLOAD =
  "FeatureFlag:EnableSnPEvidenceDownload";

export const ENABLE_PROJECTS_ZIP_DOWNLOAD_V2 =
  "FeatureFlag:EnableProjectsZipDownloadV2";

export const ONE_PROJECT_FAMILY_SETTING = "FeatureFlag:OneProjectFamilySetting";

export const LEARNING_COURSE_PERM = "FeatureFlag:LearningCourses";

export const ENABLE_STANDARDS_OUTLINE = "FeatureFlag:EnableStandardsOutline";

export const GRADING_SETUP_V2_PERM = "AdminPortal:GradingSetupV2";

export const USE_NEW_GRADING_SETUP_IN_COURSE_PERM =
  "FeatureFlag:UseNewGradingSetupInCourses";

export const IS_GRADEBOOK_TABS_NAVIGATION_ENABLED =
  "FeatureFlag:IsGradebookTabsNavigationEnabled";

export const GRADING_VISIBILITY_SETTINGS_PERM =
  "FeatureFlag:GradingVisibilitySettings";
export const GRADING_VISIBILITY_SETTINGS_V2_PERM =
  "FeatureFlag:GradingVisibilitySettingsV2";

export const LEARNING_GOALS_GRADING_PERM =
  "FeatureFlag:EnableLearningGoalsEvaluationInNewGradingSetup";

export const ASSESSMENT_SETTINGS_PERM = "AdminPortal:AssessmentSettings";
export const PROGRESS_REPORT_DISABLED_AY_WISE_PERM =
  "FeatureFlag:DisableReportSetup";

export const IS_TRANSCRIPT_DISABLED_FOR_ORG =
  "FeatureFlag:DisableTranscriptSetup";

export const OPERATIONAL_DAYS_AND_TIME_ZONE_PERM =
  "AdminPortal:EnableOperationalDaysAndTimeZone";

export const TIMETABLE_V3_PERMISSION = "FeatureFlag:TimetableV3";

export const ALLOW_MULTIPLE_PROGRAM_LANGUAGES_IN_NON_DP_PROGRAMS =
  "IdentityAccess:AllowMultipleProgramLanguagesInNonDPPrograms";

export const ENABLE_TEMPLATE_CUSTOMISATION =
  "FeatureFlag:EnableTemplateCustomisation";

export const ENABLE_TEMPLATE_PREVIEW = "AllowTemplateViewAccess";

export const ENABLE_TEMPLATE_FIELDS = "FeatureFlag:EnableTemplateFields";

export const ENABLE_DYNAMIC_LOCALISATION_OF_TEMPLATE =
  "FeatureFlag:EnableDynamicLocalisationOfTemplate";

export const ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL =
  "FeatureFlag:EnablePYPDynamicPlannerElementLabel";
export const ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL =
  "FeatureFlag:EnableMYPDynamicPlannerElementLabel";
export const ENABLE_DP_DYNAMIC_PLANNER_ELEMENT_LABEL =
  "FeatureFlag:EnableDPDynamicPlannerElementLabel";
export const ENABLE_GRADE_WISE_ASSESSMENT =
  "FeatureFlag:EnableGradeWiseAssessment";

export const ENABLE_GOOGLE_DRIVE = "Common:EnableGoogleDrive";

export const ENABLE_ONE_DRIVE = "Common:EnableOneDrive";

export const ENABLE_STUDENT_FILES_FOLDER_UPLOAD =
  "FeatureFlag:EnableFolderUploadInStudentFiles";

export const ENABLE_STUDENT_DRIVE_FOLDER_UPLOAD =
  "FeatureFlag:EnableFolderUploadInClassFiles";

export const ENABLE_STUDENT_PROFILE_UI_REVAMP =
  "FeatureFlag:EnableStudentProfileUIRevamp";

export const ENABLE_EDUCATOR_CENTRE_FOLDER_UPLOAD =
  "FeatureFlag:EnableFolderUploadInEduCenter";

export const ENABLE_DRAG_DROP_EDU_CENTRE =
  "FeatureFlag:EnableDragNDropInEduCenter";

export const ENABLE_DRAG_DROP_STUDENT_FILES =
  "FeatureFlag:EnableDragNDropInStudentFiles";

export const ENABLE_DRAG_DROP_STUDENT_DRIVE =
  "FeatureFlag:EnableDragNDropInClassFiles";

export const ENABLE_SHAREPOINT_PICKER_STAFF =
  "FeatureFlag:EnableSharepointPicker";

export const ENABLE_SHAREPOINT_PICKER_STUDENT =
  "FeatureFlag:EnableSharepointPickerStudent";

export const ENABLE_SHAREPOINT_PICKER_V2_STAFF =
  "FeatureFlag:EnableSharepointPickerV2Staff";

export const ENABLE_SHAREPOINT_FOR_SUBMISSION_TEMPLATES =
  "FeatureFlag:EnableSharepointForSubmissionTemplates";

export const ENABLE_CREATE_DRIVE_DOCUMENTS = "FeatureFlag:CreateDriveFiles";

export const ENABLE_SCHOOL_ANALYTICS = "FeatureFlag:EnableSchoolAnalytics";

export const ENABLE_DELETE_STUDENT = "FeatureFlag:EnableStudentDeletion";

export const ENABLE_DELETE_STAFF = "FeatureFlag:EnableStaffDeletion";

export const ENABLE_DELETE_VISITOR = "FeatureFlag:EnableVisitorDeletion";

export const ENABLE_SUBJECT_ARCHIVING = "FeatureFlag:SubjectArchiving";

export const ENABLE_STUDENT_BLOCKING = "FeatureFlag:StudentBlocking";

export const SCHOOL_HOMEPAGE_HIDDEN_MODULES_AND_PROJECTS =
  "SchoolHomepageHiddenModulesAndProjects";

export const SCHOOL_HOMEPAGE_MODULES_AND_PROJECTS_ORDER =
  "SchoolHomepageModulesAndProjectsOrder";

export const ORGANIZATION_LEVEL = "ORGANIZATION_LEVEL";
export const CURRICULUM_LEVEL = "CURRICULUM_LEVEL";

export const UPDATE_USER_SETTINGS = "UPDATE_USER_SETTINGS";
export const UPDATE_USER_CURRICULUM_SETTINGS =
  "UPDATE_USER_CURRICULUM_SETTINGS";
export const UPDATE_CURRICULUM_ONLY_SETTINGS =
  "UPDATE_CURRICULUM_ONLY_SETTINGS";

export const ENABLE_SNP_DOCUMENTS_TAB_FOR_TEACHER_SETTING =
  "EnableSnpDocumentsTabForTeacher";

export const ENABLE_BILINGUAL_TRANSLATION =
  "FeatureFlag:EnableBilingualTemplate";
export const ENABLE_SCHOOL_SETUP_SELECT_ALL =
  "FeatureFlag:SchoolSetupSelectAll";

export const ENABLE_ACTION_SET_EDITING = "FeatureFlag:EnableActionSetEditing";

export const ENABLE_SHORTCUT_MANAGER = "FeatureFlag:EnableShortcutManager";

export const ENABLE_GLOBAL_HEADER = "FeatureFlag:EnableGlobalHeader";

export const PROGRAMME_SWITCHER_PINNED_CURRICULUM_PROGRAMS =
  "ProgrammeSwitcherPinnedCurriculumPrograms";

export const IS_ACCOUNT_LARGE_ACCOUNT = "FeatureFlag:IsAccountLargeAccount";

export const ENABLE_ALL_SHORTCUTS = "EnableAllShortcuts";

export const ENABLE_SHORTCUT_PROMPTS = "EnableShortcutPrompts";

export const SHOW_SHORTCUT_PREFERENCES = "FeatureFlag:ShowShortcutPreferences";

export const CONTRIBUTE_UNIT_TO_COMMUNITY =
  "FeatureFlag:ContributeUnitToCommunity";

export const CONTRIBUTE_LE_TO_COMMUNITY =
  "FeatureFlag:ContributeLearningExperienceToCommunity";

export const EXCEPTIONAL_UI_TYPES = "ExceptionalUiTypes";

export const ENABLE_ADD_ADMIN_TO_ALL_CLASSES =
  "FeatureFlag:AddAdminToAllClasses";

export const ENABLE_STUDENT_MIDDLE_NAME = "FeatureFlag:EnableStudentMiddleName";
export const ENABLE_USER_MIDDLE_NAME = "FeatureFlag:EnableUserMiddleNameV2";
export const ENABLE_USER_PREFIX = "FeatureFlag:EnableUserPrefix";
export const ENABLE_USER_PRONOUNS = "FeatureFlag:EnableUserPronouns";
export const STUDENT_NAME_ORDER = "Common:StudentNameOrder";
export const STUDENTNAME_IDENTIFIER = "Common:StudentNameIdentifier";
export const STAFF_NAME_ORDER = "Common:StaffNameOrder";
export const PARENT_NAME_ORDER = "Common:ParentNameOrder";

export const STUDENT_PRINT_NAME_ORDER = "Common:StudentPrintNameOrder";
export const STAFF_PRINT_NAME_ORDER = "Common:StaffPrintNameOrder";
export const PARENT_PRINT_NAME_ORDER = "Common:FamilyPrintNameOrder";

export const ENABLE_EDIT_SUBJECT_ICON = "FeatureFlag:EditSubjectIcon";

export const ENABLE_ASSESSMENTS_IN_PYP = "FeatureFlag:EnablePYPAssessment";

export const SCHOOL_LIBRARY_VIEW_PERM = "Module:SchoolLibrary";

export const SCHOOL_LIBRARY_PERM = "TeacherPortal:SchoolLibrary";

export const BIN_PERM = "AdminPortal:EnableBinAtCurriculumLevel";

export const BIN_ACCESS_PERM = "Module:Bin";

export const ENABLE_AI_TUTOR = "FeatureFlag:AITutor";
export const ADD_ON_AI_TUTOR = "FeatureFlag:AddOnAITutor";

export const ENABLE_BULK_REMINDER = "FeatureFlag:AssignmentBulkAlerts";

export const ENABLE_BROADCAST_MESSAGE =
  "FeatureFlag:EnableAssignmentBroadcastMessage";

export const TODDLE_LIBRARY_PERM = "Module:ToddleLibrary";
export const TODDLE_LIBRARY_SHOW_ONLY_ACCESSIBLE_PERM =
  "LibraryPortal:ShowOnlyFreeResources";
export const LIBRARY_PORTAL_TODDLE_LIBRARY = "LibraryPortal:ToddleLibrary";
export const TODDLE_LIBRARY_USER_GRADE_PREFERENCE_PERM =
  "LibraryPortal:UserGradePreference";
export const TODDLE_LIBRARY_MANAGE_TABS_VISIBILITY =
  "LibraryPortal:ManageTabsVisibility";
export const TODDLE_LIBRARY_MANAGE_TABS_VISIBILITY_V2 =
  "LibraryPortal:ManageTabsVisibilityV2";
export const HIDE_TODDLE_LIBRARY_BANNER =
  "LibraryPortal:HideToddleLibraryBanner";

export const ENABLE_CUSTOM_DATA_SETS = "FeatureFlag:EnableCustomDatasets";
export const ENABLE_ROUTINE_TEMPLATES = "Common:EnableRoutines";
export const ENABLE_CLASS_ROUTINES = "EnableClassRoutines";

export const SHOW_FLAT_LIST_FOR_STANDARDS = "FeatureFlag:ShowFlatStandardsView";

export const SHOW_FLAT_LIST_FOR_ATLS = "FeatureFlag:ShowFlatATLsView";

export const ENABLE_DATASET_CUSTOMISATION =
  "FeatureFlag:EnableDatasetCustomisation";
export const ENABLE_DEPARTMENT_AND_LEVEL =
  "FeatureFlag:EnableDepartmentAndLevel";

export const ENABLE_PLANNER_ELEMENT_TRANSLATION_CONFIGURATION =
  "FeatureFlag:EnablePlannerElementTranslationConfiguration";

/** Educator Center Permissions */
export const TEACHER_PORTAL_TEACHER_SCHOOL_POLICIES =
  "TeacherPortal:TeacherSchoolPolicies";
export const TEACHER_PORTAL_TEACHER_RESOURCE = "TeacherPortal:TeacherResources";
export const STUDENT_RESOURCE = "Common:StudentResources";
export const PARENT_RESOURCE = "Common:ParentResources";
export const ADMIN_PORTAL_PARENT_SCHOOL_POLICIES =
  "AdminPortal:ParentSchoolPolicies";
export const STUDENT_SCHOOL_POLICIES = "Common:StudentSchoolPolicies";
export const ADMIN_RESOURCE = "AdminPortal:AdminResources";
export const ADMIN_PORTAL_TEACHER_SCHOOL_POLICIES =
  "AdminPortal:TeacherSchoolPolicies";
export const ADMIN_PORTAL_TEACHER_RESOURCE = "AdminPortal:TeacherResources";
export const ADMIN_PORTAL_WORKBOOK_TEMPLATE = "AdminPortal:WorkbookResource";
export const FAMILY_PORTAL_PARENT_SCHOOL_POLICIES =
  "FamilyPortal:ParentSchoolPolicies";
export const FAMILY_APP_SCHOOL_POLICIES = "FamilyApp:SchoolPolicies";

export const EDUCATOR_CENTER_REVAMP = "Common:EducatorCenterRevamp";
export const EDUCATOR_CENTER_REVAMP_PARENT_PERM =
  "Common:EnableSchoolPoliciesAndResources";
export const SCHOOL_POLICIES_FOR_CCH = "FeatureFlag:schoolPoliciesForCCHV2";
export const SCHOOL_POLICIES_FOR_ACCOUNT =
  "Module:SchoolPoliciesAndResourcesForAccount";

export const CLASS_DRIVE_ACCESS_PERMISSION = "Module:ClassDrive";
export const CAN_UPLOAD_AND_ORGANISE_CLASS_DRIVE =
  "ClassDrive:CanUploadAndOrganiseClassDrive";

export const ALLOW_TEACHER_TO_EDIT_MODULE_SETTINGS = "OverrideModuleSettings";

export const ENABLE_USER_ACADEMIC_YEAR_ARCHIVAL_STATUS =
  "FeatureFlag:EnabledUserAcademicYearArchivalStatus";

export const ENABLE_FILTERED_DATA_DOWNLOAD = "FeatureFlag:FilteredDataDownload";

export const ENABLE_IBECOURSEWORK = "Module:Ibecoursework";

export const ENABLE_GLOBAL_HEADER_ON_MULTIPLE_SCREENS =
  "FeatureFlag:EnableGlobalHeaderOnMultipleScreens";

export const ENABLE_ROLES_AND_PERMISSIONS_CONFIGURATION =
  "FeatureFlag:EnableRolesAndPermissionsConfiguration";

export const ENABLE_ROLES_AND_PERMISSIONS_PERMISSION =
  "Module:RolesAndPermissions";

export const ENABLE_TRANSCIRPT_DOWNLOAD_REVAMP =
  "FeatureFlag:ShowTranscriptsDownloadRevamp";

export const IBIS_REGISTRATION_ACCESS_PERMISSION = "Module:IbisRegistration";

export const BEHAVIOUR_RNP_CONFIGURATION_PERMISSION =
  "FeatureFlag:RolesAndPermissionsBehaviourV2";

export const CAN_MANAGE_BEHAVIOUR_RNP_ACCESS_PERMISSION =
  "BehaviourSetup:CanManageBehaviourRolesAndPermissions";

export const BEHAVIOUR_RNP_CONSUMPTION_PERMISSION = "Behaviour:EnableModuleRnP";

export const BEHAVIOUR_RNP_ACCOUNT_LEVEL_MODULE_SETTING =
  "Module:BehaviourDashboardV2ForAccount";

export const BEHAVIOUR_RNP_PROGRAMME_LEVEL_MODULE_SETTING =
  "Module:BehaviourDashboardV2ForProgramme";

export const BEHAVIOUR_SETUP_ACCESS_PERMISSION = "Module:BehaviourSetup";

export const BEHAVIOUR_DASHBOARD_ACCESS_PERMISSION =
  "Module:BehaviourDashboard";
export const BEHAVIOUR_CAN_CREATE_INCIDENT_PERMISSION =
  "BehaviourDashboard:CanCreateIncident";
export const BEHAVIOUR_CAN_VIEW_INCIDENT_PERMISSION =
  "BehaviourDashboard:CanViewAllIncidents";
export const BEHAVIOUR_CAN_EDIT_INCIDENT_PERMISSION =
  "BehaviourDashboard:CanEditIncidents";
export const BEHAVIOUR_CAN_VIEW_INCIDENT_AND_CONFIDENTIAL_PERMISSION =
  "BehaviourDashboard:CanViewAllIncidentsAndConfidentialityNotes";
export const BEHAVIOUR_CAN_EDIT_INCIDENT_AND_VIEW_CONFIDENTIAL_PERMISSION =
  "BehaviourDashboard:CanEditAllIncidentsAndViewConfidentialityNotes";
export const BEHAVIOUR_CAN_EDIT_INCIDENT_AND_CONFIDENTIAL_PERMISSION =
  "BehaviourDashboard:CanEditAllIncidentsAndConfidentialityNotes";

export const BEHAVIOUR_MANAGEMENT_TOGGLE_MODULES_PERMISSION =
  "Module:BehaviourDashboard";

export const BEHAVIOUR_RNP_MODULE_SETTINGS = [
  BEHAVIOUR_RNP_ACCOUNT_LEVEL_MODULE_SETTING,
  BEHAVIOUR_RNP_PROGRAMME_LEVEL_MODULE_SETTING,
];

export const ACCOUNT_LEVEL_BEHAVIOUR_DASHBOARD_ACCESS_PERMISSION =
  "BehaviourDashboardV2ForAccount:CanViewBehaviourDashboard";

export const PROGRAMME_LEVEL_BEHAVIOUR_DASHBOARD_ACCESS_PERMISSION =
  "BehaviourDashboardV2ForProgramme:CanViewBehaviourDashboard";

export const ENABLE_RNP_CONSUMPTION_IN_BEHAVIOUR = "EnableRnPInBehaviour";

export const CLASS_FLOW_VIEW_PERMISSION = "Module:ClassFlow";

export const CLASS_FLOW_EDIT_PERMISSION =
  "ClassFlow:CanOrganiseAssignmentsAndResourcesInClassFlow";

export const CAN_VIEW_CONTINUUM_MODULE_SETTING = "Module:Continuum";

export const AY_WISE_PERM_SETUP_PERMISSION = "FeatureFlag:isAYWisePermsSetup";

export const TODDLE_2_O_PERMISSION = "FeatureFlag:IsToddle2.0Enabled";

export const CAN_VIEW_COURSE_FLOW_PERMISSION = "Module:CourseFlow";
export const CAN_EDIT_COURSE_FLOW_PERMISSION =
  "CourseFlow:CanAddAndOrganiseAssignmentsAndResourcesInCourseFlow";
export const CAN_ASSIGN_COURSE_CONTENT_PERMISSION =
  "CourseFlow:CanAssignCourseContent";

export const CAN_VIEW_COURSE_ASSESSMENT_TOOLS_PERMISSION =
  "Module:AssessmentTools";

export const MANAGE_COURSE_ASSESSMENT_TOOLS_PERMISSION =
  "AssessmentTools:ManageAssessmentTools";

export const CAN_VIEW_COURSE_SETTINGS_PERMISSION = "Module:CourseSettings";

export const MANAGE_COURSE_ASSOCIATED_CLASSES_PERMISSION =
  "CourseSettings:CanConfigureAssociatedClasses";

export const MANAGE_COURSE_STAFF_MEMBERS_PERMISSION =
  "CourseSettings:CanConfigureStaffMembers";

export const MANAGE_COURSE_MYP_CRITERIA_PERMISSION =
  "CourseSettings:CanConfigureMYPCriteria";
export const MANAGE_COURSE_GRADE_SCALES_PERMISSION =
  "CourseSettings:CanConfigureGradeScales";
export const MANAGE_COURSE_GRADING_CONFIG_PERMISSION =
  "CourseSettings:CanConfigureCalculationSetup";
export const MANAGE_COURSE_GRADING_CATEGORIES_PERMISSION =
  "CourseSettings:CanConfigureAssessmentCategories";
export const MANAGE_COURSE_GRADING_VISIBILITY_PERMISSION =
  "CourseSettings:CanManageGradingVisibility";

export const MANAGE_LOCK_CONFIGURATION_PERMISSION =
  "CourseSettings:CanLockConfigurations";

export const MANAGE_COURSE_ICON = "CourseSettings:ManageCourseIcon";

export const CAN_MANAGE_COURSE_STANDARDS = "Module:Standards";
export const CAN_MANAGE_STANDARDS = "Standards:ManageStandards";

export const ENABLE_STUDENT_ALERTS = "FeatureFlag:EnableStudentAlerts";

export const CAN_VIEW_STUDENT_ALERT_SETTINGS = "Module:StudentAlertSettings";

export const STATIC_WIDGETISED_SCHOOL_HOMEPAGE =
  "FeatureFlag:StaticWidgetisedSchoolHomepage";

export const STATIC_WIDGETISED_SCHOOL_HOMEPAGE_V0 =
  "FeatureFlag:StaticWidgetisedSchoolHomepageV0";

export const SHOW_COURSE_HOMEPAGE_FOR_PARENT_PORTAL =
  "ShowCourseHomePageForParentPortal";

export const SHOW_COURSE_HOMEPAGE_FOR_STUDENT_PORTAL =
  "ShowCourseHomePageForStudentPortal";

export const CAN_VIEW_COURSE_HOME_PAGE = "Module:HomePageForCourses";

export const CAN_MANAGE_NAVIGATION_SETTINGS =
  "CourseSettings:CanManageNavigationSettings";

export const COURSE_AND_CLASS_NAVIGATION_SETTING =
  "FeatureFlag:CourseAndClassNavigationSetting";

export const WIDGETISED_COURSE_HOMEPAGE =
  "FeatureFlag:WidgetisedCourseHomepage";

export const WIDGETISED_SCHOOL_HOMEPAGE =
  "FeatureFlag:WidgetisedSchoolHomepage";

export const CAN_MANAGE_COURSE_HOME_PAGE =
  "HomePageForCourses:CanManageHomePageForCourses";

export const ENABLE_LTI_LAUNCH_FAIL_SAFE_BUTTON =
  "FeatureFlag:EnableLTILaunchFailSafeButton";

export const CAN_VIEW_LTI_TOOLS = "Module:LTITools";

// Configuration for LTI tools visibility on student & staff portal
export const CAN_VIEW_LTI_TOOLS_CONFIG = "Common:LTIToolsInCourseContext";

export const SHOW_COURSE_DISPLAY_NAME = "FeatureFlag:ShowCourseDisplayName";

const IDENTITY_CONFIGURATIONS = {
  [ACCESS_MANAGER]: "IdentityAccess:AccessManager",
  [ACCESS_MANAGER_REQUEST]: "IdentityAccess:AccessManagerRequest",
  [MANAGE_USERS]: "IdentityAccess:ManageUsers",
  [ORGANIZATIONS]: "IdentityAccess:Organizations",
  [VIEW_CONFIGURATION_TOOL]: "IdentityAccess:ConfigurationTool",
  [WRITE_CONFIGURATION_TOOL]: "IdentityAccess:ConfigurationToolWrite",
  [WRITE_VALUE_CONFIGURATION_TOOL]:
    "IdentityAccess:ConfigurationToolWriteValue",
  [TEMPLATE_EDITOR]: "IdentityAccess:ManageTemplates",
  [INTERNAL_TOOLS]: "IdentityAccess:InternalTools",
  [ACTIVATE_SCHOOLS]: "IdentityAccess:ActivateSchools",
  [CREATE_ORGANIZATION]: "IdentityAccess:CreateOrganization",
  [DELETE_ORGANIZATION]: "IdentityAccess:DeleteOrganization",
  [GRAPHQL_PLAYGROUND]: "IdentityAccess:GraphqlPlayground",
  [SWITCH_SCHOOL_USERNAME]: "IdentityAccess:SwitchSchoolUserName",
  [INTERNAL_PORTAL_ACCESS]: "IdentityAccess:InternalPortal",
  [ALLOW_ELASTICACHE_MANAGEMENT]: "IdentityAccess:AllowElasticacheManagement",
  [ELASTICACHE_FLUSHDB_ALLOWED_IDENTITIES]:
    "IdentityAccess:ElasticacheFlushDBAllowedIdentities",
  [ALLOW_ELASTICACHE_AUDIT_LOG_VIEWING]:
    "IdentityAccess:AllowElasticacheManagerAuditLogViewing",
};

const PAM_CONFIGURATIONS = {
  [PLATFORM_ACCESS_MANAGER]: [
    IDENTITY_CONFIGURATIONS[ACCESS_MANAGER],
    IDENTITY_CONFIGURATIONS[ACCESS_MANAGER_REQUEST],
    IDENTITY_CONFIGURATIONS[MANAGE_USERS],
    IDENTITY_CONFIGURATIONS[ORGANIZATIONS],
    IDENTITY_CONFIGURATIONS[VIEW_CONFIGURATION_TOOL],
    IDENTITY_CONFIGURATIONS[WRITE_CONFIGURATION_TOOL],
  ],
};

const TOOL_CONFIGURATIONS = {
  [TOOLS]: [
    IDENTITY_CONFIGURATIONS[TEMPLATE_EDITOR],
    IDENTITY_CONFIGURATIONS[INTERNAL_TOOLS],
    IDENTITY_CONFIGURATIONS[ACTIVATE_SCHOOLS],
  ],
};

const INTERNAL_PORTAL_CONFIGURATIONS = {
  [INTERNAL_PORTAL]: [
    ...PAM_CONFIGURATIONS[PLATFORM_ACCESS_MANAGER],
    ...TOOL_CONFIGURATIONS[TOOLS],
  ],
};

const VIEW_CONFIGURATION_TOOL_CONFIGURATIONS = {
  [VIEW_CONFIGURATIONS]: [
    IDENTITY_CONFIGURATIONS[VIEW_CONFIGURATION_TOOL],
    IDENTITY_CONFIGURATIONS[WRITE_CONFIGURATION_TOOL],
    IDENTITY_CONFIGURATIONS[WRITE_VALUE_CONFIGURATION_TOOL],
  ],
};

export const IDENTITY_CONFIGURATION_TYPE_TO_PERM_MAP = {
  ...IDENTITY_CONFIGURATIONS,
  ...PAM_CONFIGURATIONS,
  ...TOOL_CONFIGURATIONS,
  ...VIEW_CONFIGURATION_TOOL_CONFIGURATIONS,
  ...INTERNAL_PORTAL_CONFIGURATIONS,
};

export const ENABLE_AY_TRANSITION = "FeatureFlag:AcademicYearTransition";
export const SHOW_AYT_FILES_BUTTON = "AdminPortal:showDownloadAYTFileButton";
export const ENABLE_FUTURE_AY_IN_TEACHER_PORTAL_AY_SWITCHER =
  "TeacherPortal:ShowNextAcademicYear";

export const REMOVE_CLASS_LEVEL_MODULE_SETTINGS =
  "FeatureFlag:RemoveModuleSettingsToggleForClassLevel";

export const ENABLE_CAS_EXTERNAL_SUPERVISOR =
  "FeatureFlag:CASExternalSupervisor";

export const ENABLE_CROSS_CURRICULUM_STUDENTS =
  "FeatureFlag:EnableCrossCurriculumStudents";

export const ENABLE_YEARWISE_VIEW_ASSOCIATED_UNITS =
  "FeatureFlag:AssociatedUnitsClassesAcademicYearWise";

export const ALLOW_DATASET_RENAME = "FeatureFlag:AllowDatasetRename";

export const ENROL_STUDENT_FLOW = "FeatureFlag:StudentEnrollmentFlow";

export const BULK_ENROL_STUDENT_FLOW = "FeatureFlag:StudentBulkEnrollment";

export const STAFF_ENROLLMENT_UNENROLLMENT_FLOW =
  "FeatureFlag:StaffBulkEnrollmentAndUnenrollment";

export const DISABLE_PUBLISH_FOR_MAPLE_BEAR =
  "FeatureFlag:DisablePublishAllForMapleBear";

export const ENABLE_TODDLE_ANALYTICS = "Module:Analytics";
export const ENABLE_ENGAGEMENT_ANALYTICS =
  "Analytics:CanViewEngagementAnalytics";
export const ENABLE_PERFORMANCE_ANALYTICS =
  "Analytics:CanViewPerformanceAnalytics";
export const ENABLE_BEHAVIOUR_ANALYTICS = "Analytics:CanViewBehaviourAnalytics";
export const ENABLE_MODULE_USAGE_ANALYTICS =
  "Analytics:CanViewModuleUsageAnalytics";
export const TODDLE_ANALYTICS_USER_BASED_ACCESS_PERM =
  "Analytics:ToddleAnalyticsUserBasedAccess";
export const ENABLE_ATTENDANCE_ANALYTICS = "Analytics:AttendanceAnalytics";
export const TODDLE_ANALYTICS_PERMISSION = "Analytics:ToddleAnalytics";
export const ENGAGEMENT_ANALYTICS_PERMISSION = "Analytics:EngagementAnalytics";
export const PERFORMANCE_ANALYTICS_PERMISSION =
  "Analytics:PerformanceAnalytics";
export const MODULE_USAGE_ANALYTICS_PERMISSION =
  "Analytics:ModuleUsageAnalytics";
export const BEHAVIOUR_ANALYTICS_PERMISSION = "Analytics:BehaviourAnalytics";
export const ATTENDANCE_ANALYTICS_PERMISSION = "Analytics:AttendanceAnalytics";
export const ENABLE_INSIGHTS_PLAYGROUND = "FeatureFlag:AIAnalyticsPlayground";

export const ENABLE_BEHAVIOUR_MODULE_PERM = "FeatureFlag:BehaviourManagement";
export const ENABLE_BEHAVIOUR_DATE_RANGE_FILTER =
  "Behaviour:EnableDateRangeFilter";
export const ENABLE_BEHAVIOUR_MODULE_IN_ADMIN_PORTAL =
  "FeatureFlag:BehaviourAdminPortal";
export const ENABLE_BEHAVIOUR_SETUP_CARD = "EnableBehaviourSetupCard";
export const ENABLE_DESCRIPTION_TEMPLATE_IN_BEHAVIOUR =
  "Behaviour:EnableDescriptionTemplates";

export const ENABLE_ROLES_AND_PERMISSIONS_TOOL = "RnPInternalTool:ViewToolCard";

export const ENABLE_IBIS_UI_REVAMP = "FeatureFlag:EnableIBISUIRevamp";

export const ENABLE_ADD_ON_IBIS_REVAMP = "FeatureFlag:AddOnIBISRevamp";

export const ENABLE_ADD_ON_ROSTER_SYNC = "FeatureFlag:AddOnForRosterSync";
export const ENABLE_ADD_ON_TIMETABLE_ATTENDANCE_SYNC =
  "FeatureFlag:AddOnForTimetableAttendanceSync";

export const ENABLE_PULL_MISSING_DATA_FROM_ROSTER = "IBIS:EnablePullFromRoster";

export const ENABLE_MCGRAW_HILL_LTI_TOOL = "Common:EnableMcGrawHillLTITool";

export const CAN_VIEW_ANNOUNCEMENT_MODULE = "Module:Announcements";
export const CLASS_ANNOUNCEMENT_FEATURE_FLAG = "FeatureFlag:ClassAnnouncement";
export const CAN_VIEW_CLASS_ANNOUNCEMENT_MODULE = "Module:ClassAnnouncements";

/**Staff profile permissions */
export const STAFF_PROFILE_ACCESS_PERMISSION = "Module:StaffProfile";

export const STAFF_PROFILE_OTHER_STAFF_ACCESS_PERMISSION =
  "StaffProfile:CanManageStaffProfile";

const PRE_LOAD_VISITOR_PERMISSIONS = [
  "AppSettingSnpModuleLabel",
  "VisitorPortal:SnpV2",
  "AppSettingSnpRequirementLabel",
  "AppSettingSnpRequirementPluralLabel",
  "Common:SnpV2",
];

// Planning insights perms
export const PLANNING_INSIGHTS_COURSE_LEVEL_VIEW_PERMISSION =
  "Module:PlanningInsightsCourse";
export const PLANNING_INSIGHTS_PROGRAMME_LEVEL_VIEW_PERMISSION =
  "Module:PlanningInsightsProgramme";
export const PLANNING_INSIGHTS_CONFIGURE_UNITS_PERMISSION =
  "PlanningInsights:CanConfigureUnitsIncludedInPlanningInsights";

export const SHOW_CUSTOM_DATASET_INSIGHTS =
  "FeatureFlag:ShowInsightsForCustomDatasets";

export const SHOW_SINGLE_TABLE_INSIGHTS =
  "FeatureFlag:SingleTableStandardsInsights";

// Progress report permissions
export const PROGRESS_REPORTS_PROGRAMME_LEVEL_VIEW_PERMISSION =
  "Module:ProgressReports";
export const PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION =
  "Module:ReportSetup";
export const TRANSCRIPT_ADMIN_LEVEL_VIEW_PERMISSION = "Module:TranscriptSetup";
export const ATTENDANCE_EDIT_PERMISSION =
  "ProgressReports:CanEditAttendanceInReports";

// TranscriptV3 permissions
export const TRANSCRIPT_FOR_ACCOUNT_LEVEL_VIEW_PERMISSION =
  "Module:TranscriptsForAccount";
export const TRANSCRIPT_CAN_MANAGE_TEMPLATES_PERMISSION =
  "TranscriptsForAccount:CanManageTranscriptTemplates";
export const TRANSCRIPT_FOR_PROGRAMME_LEVEL_VIEW_PERMISSION =
  "Module:TranscriptsForProgram";
export const TRANSCRIPT_FOR_PROGRAMME_CAN_MANAGE_TEMPLATES_PERMISSION =
  "TranscriptsForProgram:CanManageTranscriptsTemplates";
export const TRANSCRIPT_CAN_MANAGE_ACADEMIC_RECORDS_PERMISSION =
  "TranscriptsForProgram:CanManageAcademicRecords";
export const TRANSCRIPT_CAN_MANAGE_TRANSCRIPT_DOWNLOAD_PERMISSION =
  "TranscriptsForProgram:CanManageTranscriptDownloads";

export const HOMEPAGE_LAYOUT_PREFERENCE = "HomePageLayout";

/**
 * User-level preference to track dismissed persistent toast notifications.
 * Stored as JSON: { video_meeting: ["eventId1", "eventId2", ...] }
 * IDs older than 24 hours are pruned on each write to keep the value compact.
 */
export const USER_DISMISSED_TOAST_PREFERENCE =
  "Common:UserDismissedToastPreference";

export const GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS = {
  MODULES_SEARCH: "GlobalSearch:ModulesSearch",
  UNITS_SEARCH: "GlobalSearch:UnitsSearch",
  TASKS_SEARCH: "GlobalSearch:TasksSearch",
  STUDENTS_SEARCH: "GlobalSearch:StudentsSearch",
  STAFF_SEARCH: "GlobalSearch:StaffSearch",
  FAMILY_SEARCH: "GlobalSearch:FamilySearch",
  REPORTS_SEARCH: "GlobalSearch:ReportsSearch",
  INSIGHTS_SEARCH: "GlobalSearch:InsightsSearch",
  CLASSES_SEARCH: "GlobalSearch:ClassSearchV3",
  COURSES_SEARCH: "GlobalSearch:LearningCourseSearch",
};

export const ENABLE_ADMIN_NAVIGATION_REVAMP =
  "FeatureFlag:EnableNewAdminNavigationFor1.0Orgs";
export const COMBINE_CURRICULUM_HOME_PAGE_PERMISSION =
  "FeatureFlag:CombineCurriculumHomePage";

export const ENABLE_CALENDAR_REVAMP_PHASE_1 =
  "FeatureFlag:EnableCalendarRevampPhase1";

export const ENABLE_SENTRAL_PORTAL_WELLBEING_BUTTON =
  "FeatureFlag:EnableSentralWellbeingPortalButton";
export const ENABLE_SENTRAL_PORTAL_ATTENDANCE_BUTTON =
  "FeatureFlag:EnableSentralAttendancePortalButton";
export const ENABLE_SENTRAL_PORTAL_TIMETABLE_BUTTON =
  "FeatureFlag:EnableSentralTimetablePortalButton";
export const ENABLE_SENTRAL_PORTAL_DASHBOARD_BUTTON =
  "FeatureFlag:EnableSentralDashboardPortalButton";
export const ENABLE_SENTRAL_PORTAL_POLICIES_AND_RESOURCES_BUTTON =
  "FeatureFlag:EnableSentralPoliciesAndResourcesPortalButton";
export const ENABLE_SENTRAL_PORTAL_STUDENT_PROFILE_BUTTON =
  "FeatureFlag:EnableSentralStudentProfilePortalButton";
export const ENABLE_SENTRAL_NEWSFEED_BUTTON =
  "FeatureFlag:EnableSentralNewsfeedPortalButton";
export const ENABLE_SENTRAL_NOTICE_BUTTON =
  "FeatureFlag:EnableSentralDailyNoticesPortalButton";
export const ENABLE_SENTRAL_DOCUMENTS_BUTTON =
  "FeatureFlag:EnableSentralDocumentsPortalButton";
export const ENABLE_SENTRAL_PXP_BUTTON =
  "FeatureFlag:EnableSentralPxpPortalButton";
export const ENABLE_WALKME_INTEGRATION = "FeatureFlag:EnableWalkMeIntegration";
export const ENABLE_SENTRAL_QUEST_WEEK_BUTTON =
  "FeatureFlag:EnableSentralQuestWeekWidget";
export const ENABLE_SENTRAL_SPORTS_BUTTON =
  "FeatureFlag:EnableSentralSportsPortalButton";
export const ENABLE_SENTRAL_PORTAL_ACTIVITY_BUTTON =
  "FeatureFlag:EnableSentralActivityPortalButton";

export const ENABLE_ACCOUNT_CONFIGURATION =
  "FeatureFlag:EnableAccountConfiguration";

export const ENABLE_INTERCOM_CONSUMPTION =
  "FeatureFlag:EnableIntercomConsumption";

export const AI_INSIGHTS_RESPONSE_CONFIGURATION =
  "Configuration:AIInsightsResponse";

export const ENABLE_AI_INSIGHTS_DASHBOARD_LAYOUT_CUSTOMIZATION =
  "FeatureFlag:AIInsightsDashboardLayoutCustomization";

export const AI_INSIGHTS_SMART_FILTERS = "FeatureFlag:AIInsightsSmartFilters";

export const SHOW_LOGGED_IN_DETAILS_FOR_FAMILY_MEMBERS =
  "FeatureFlag:ShowLoggedInDetailsForFamily";

export const ENABLE_EXAM_SESSION_ON_CURRICULUM =
  "FeatureFlag:EnableExamSessionOnCurriculum";

export const ALLOW_PLANNER_AND_GRADING_SETUP_OVERRIDES =
  "IdentityAccess:AllowPlannerAndGradingOverrides";

export const ENABLE_1P0_TO_2P0_AYT = "IdentityAccess:1p0To2p0AYT";

export const ENABLE_PROGRAM_SECTIONS_IN_ACCOUNT_ADMIN_PORTAL =
  "FeatureFlag:EnableProgramSectionsInAccountAdminPortal";

export const ENABLE_CONFIGURATION_FETCHING_OPTIMISATION =
  "FeatureFlag:EnableConfigurationFetchingOptimisation";

export const ENABLE_POWER_BI_CARDS = "FeatureFlag:EnablePowerBiCards";

export const ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION =
  "FeatureFlag:EnableRolesAndPermissionsConsumption";

const PRE_LOAD_ORGANIZATION_LEVEL_STAFF_PERMISSIONS = [
  "StaffPermission:FeatureFlag",
  "FeatureFlag:PDFTronRevampedUI",
  "FeatureFlag:IntercomV2",
  "FeatureFlag:EnableSprinkalrChatSupport",
  "FeatureFlag:EnableGlobalMenuTray",
  "FeatureFlag:EnableMeetingsTabInNotification",
  "FeatureFlag:StudentAnnouncementTab",
  "FeatureFlag:MessagingV2",
  "FeatureFlag:WorkrampAcademy",
  "TeacherPortal:GlobalSearchBar",
  "Common:EnableHelpCenter",
  "Common:ShowProductUpdates",
  "FeatureFlag:ShowContactSupport",
  "FeatureFlag:IsSentrySessionReplayEnabled",
  "FeatureFlag:ShowAllYearGroupProjectGroups",
  SNPv2_PERM,
  SNPv2_TEACHER_MODULE_PERM,
  "FeatureFlag:ValentineMessage",
  "FeatureFlag:IsMapleBearLikeOrg",
  "FeatureFlag:ShowProjectsInFutureAY",
  "TeacherPortal:Community",
  "FeatureFlag:AnnouncementV2",
  "TeacherPortal:AttendanceDashboard",
  "FeatureFlag:ShowLearnAndInspire",
  "TeacherPortal:ShowNextAcademicYear",
  "FeatureFlag:AcademicYearSwitcher",
  "TeacherPortal:ChangeLanguage",
  "IdentityAccess:AccessManager",
  "IdentityAccess:AccessManagerRequest",
  "IdentityAccess:ManageUsers",
  "IdentityAccess:Organizations",
  "IdentityAccess:ConfigurationTool",
  "IdentityAccess:ConfigurationToolWrite",
  "IdentityAccess:ConfigurationToolWriteValue",
  "IdentityAccess:ManageTemplates",
  "IdentityAccess:InternalTools",
  "IdentityAccess:ActivateSchools",
  "IdentityAccess:CreateOrganization",
  "IdentityAccess:SwitchSchoolUsername",
  "IdentityAccess:hubspotProgramDataSync",
  "IdentityAccess:InternalPortal",
  "IdentityAccess:Toddle2.0OrgCreation",
  "IdentityAccess:ShowAllOrganizations",
  "IdentityAccess:AccessManagerUserRequest",
  "IdentityAccess:EditWorkrampAcademyList",
  "IdentityAccess:AllOrgFeedView",
  "IdentityAccess:ManageIdentityPermissions",
  "IdentityAccess:AllowElasticacheManagement",
  "IdentityAccess:ElasticacheFlushDBAllowedIdentities",
  "IdentityAccess:AllowElasticacheManagerAuditLogViewing",
  "disableSentry",
  "disableMixPanel",
  "disableIntercom",
  "disableAbly",
  "disableGoogleAnalytics",
  "disableUpVoty",
  "FeatureFlag:showTheatreModeV2",
  "Common:PersonalProject",
  "Common:CommunityProject",
  "Common:ServiceAsAction",
  "Common:EEProjects",
  "Common:CASPortfolio",
  "Common:TOKEssayProjects",
  "Common:TOKExhibitionProjects",
  "Common:Group4AndCollaborativeSciences",
  "Common:ReflectiveProject",
  "Common:ServiceLearning",
  "SpawnSingleAblyConnection",
  "AdminPortal",
  "FeatureFlag:ShowNotificationInGlobalTray",
  "Common:ShowConsolidatedDeadlines",
  TODDLE_LIBRARY_SHOW_ONLY_ACCESSIBLE_PERM,
  "TeacherPortal:StudentPortfolio",
  "TeacherPortal:FamilyProfile",
  "TeacherPortal",
  "Common:Announcement",
  "Common:EnableSchoolPoliciesAndResources",
  "Common:EducatorCenterRevamp",
  "TeacherPortal:AttendanceManager",
  "TeacherPortal:ClassroomTodo",
  "StudentPortal:Todos",
  "Common:PlatformCalendar",
  "TeacherPortal:FamilyCommunications",
  "AdminPortal:UnitsTrash",
  "AdminPortal:LesTrash",
  "AdminPortal:Circular",
  "AdminPortal:UnitPlans",
  "Common:AdminPortal",
  "AdminPortal:PlanningInsights",
  "AdminPortal:DPPlanningInsights",
  "AdminPortal:Settings",
  "TeacherPortal:Scheduler",
  "TeacherPortal:SchedulerMYP",
  "TeacherPortal:SchedulerUBD",
  "TeacherPortal:SchedulerDP",
  "TeacherPortal:PlanningInsights",
  "TeacherPortal:DPPlanningInsights",
  "TeacherPortal:UBD_Atls",
  "TeacherPortal:ScopeAndSequance",
  "Common:Classroom",
  "Common:Continuum",
  "Common:Portfolio",
  "TeacherPortal:Attendance",
  "TeacherPortal:ProgressReport",
  "TeacherPortal:TeacherResources",
  "TeacherPortal:UnitLibrary",
  "TeacherPortal:LELibrary",
  "TeacherPortal:LELibraryMyp",
  "TeacherPortal:LELibraryUbd",
  "TeacherPortal:ShowOldClassSetting",
  "TeacherPortal:AssessmentEvaluation",
  "TeacherPortal:TeacherSchoolPolicies",
  "TeacherPortal:ClassSetting",
  "Common:NotificationConfiguration",
  "TeacherPortal:ManageFamilyMembers",
  "TeacherPortal:POI",
  "Common:AttendanceDashboard",
  "Common:LearnerPortfolio",
  "Common:StudentGoals",
  "Common:Homeroom",
  "FeatureFlag:SubjectCenter",
  "FeatureFlag:BehaviourManagement",
  ENABLE_RNP_CONSUMPTION_IN_BEHAVIOUR,
  "FeatureFlag:EnableGlobalHeaderOnMultipleScreens",
  SCHOOL_LIBRARY_PERM,
  "TeacherPortal:EducationCenter",
  "TeacherPortal:ContentSkills",
  "TeacherPortal:ManageSchools",
  "TeacherPortal:ManageUnitPublish",
  "TeacherPortal:DPProgressReports",
  "TeacherPortal:MYPProgressReports",
  "TeacherPortal:UBDProgressReports",
  "FeatureFlag:EnableGlobalHeader",
  "FeatureFlag:EnableGlobalSearchJumpToRevamp",
  "FeatureFlag:EnableGlobalSearchJumpToV2",
  "FeatureFlag:BehaviourAdminPortal",
  "AdminPortal:DPExamRegistration",
  "Common:IbECoursework",
  "AdminPortal:StaffPermissions",
  "FeatureFlag:WorkrampAcademyAnalytics",
  "AdminPortal:Gradebook",
  "AdminPortal:YearGroupManager",
  "AdminPortal:ProgressReports",
  "AdminPortal:MYPProgressReports",
  "AdminPortal:UBDProgressReports",
  "AdminPortal:DPProgressReports",
  "AdminPortal:Transcripts",
  "FeatureFlag:AdminTimetable",
  "FeatureFlag:ProductFruits",
  "FeatureFlag:InternalNPS",
  "Common:EnableRoutines",
  BIN_PERM,
  ENABLE_SHORTCUT_MANAGER,
  TODDLE_ANALYTICS_USER_BASED_ACCESS_PERM,
  TODDLE_2_O_PERMISSION,
  HOMEPAGE_LAYOUT_PREFERENCE,
  TODDLE_ANALYTICS_PERMISSION,
  ENGAGEMENT_ANALYTICS_PERMISSION,
  PERFORMANCE_ANALYTICS_PERMISSION,
  MODULE_USAGE_ANALYTICS_PERMISSION,
  BEHAVIOUR_ANALYTICS_PERMISSION,
  ATTENDANCE_ANALYTICS_PERMISSION,
  HIDE_TODDLE_LIBRARY_BANNER,
  ENABLE_ADMIN_NAVIGATION_REVAMP,
  ENABLE_ACCOUNT_CONFIGURATION,
  ENABLE_CALENDAR_REVAMP_PHASE_1,
  ENABLE_SENTRAL_PORTAL_ATTENDANCE_BUTTON,
  ENABLE_SENTRAL_PORTAL_POLICIES_AND_RESOURCES_BUTTON,
  ENABLE_SENTRAL_PORTAL_TIMETABLE_BUTTON,
  ENABLE_SENTRAL_PORTAL_WELLBEING_BUTTON,
  TODDLE_2_O_PERMISSION,
  ENABLE_SENTRAL_NEWSFEED_BUTTON,
  ENABLE_SENTRAL_NOTICE_BUTTON,
  ENABLE_SENTRAL_PXP_BUTTON,
  ENABLE_INTERCOM_CONSUMPTION,
  SHOW_LOGGED_IN_DETAILS_FOR_FAMILY_MEMBERS,
  AI_INSIGHTS_RESPONSE_CONFIGURATION,
  BEHAVIOUR_RNP_CONSUMPTION_PERMISSION,
  "FeatureFlag:EnableIntercomAusWorkspace",
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.MODULES_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.UNITS_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.TASKS_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.STUDENTS_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.STAFF_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.FAMILY_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.REPORTS_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.INSIGHTS_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.CLASSES_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.COURSES_SEARCH,
  STATIC_WIDGETISED_SCHOOL_HOMEPAGE_V0,
  ENABLE_PROGRAM_SECTIONS_IN_ACCOUNT_ADMIN_PORTAL,
  ENABLE_CONFIGURATION_FETCHING_OPTIMISATION,
  SCHOOL_HOMEPAGE_HIDDEN_MODULES_AND_PROJECTS,
  SCHOOL_HOMEPAGE_MODULES_AND_PROJECTS_ORDER,
  ENABLE_POWER_BI_CARDS,
  ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
  ENABLE_ROLES_AND_PERMISSIONS_CONFIGURATION,
  WIDGETISED_SCHOOL_HOMEPAGE,
];

/**
 * NOTE:
 * If you are updating any module related permission in the below array,
 * Please make sure to update the same in the perms array of
 * GLOBAL_SEARCH_AND_JUMP_TO_MODULES in typesConfig object.
 */
const PRE_LOAD_CURRICULUM_LEVEL_STAFF_PERMISSIONS = [
  "Common:Announcement",
  "TeacherPortal:ProgressReport",
  "Common:EnableToddleAcademy",
  "Common:Homeroom",
  "StaffPermission:EvaluationCyclesAvailability",
  "StaffPermission:EvaluationCycles",
  "Common:Classroom",
  "Common:PlatformCalendar",
  "Common:StudentGoals",
  "Common:AttendanceDashboard",
  "StaffPermission:Attendance",
  "TeacherPortal:FamilyCommunications",
  "StaffPermission:FamilyMessagingAvailability",
  "StaffPermission:FamilyMessaging",
  "StaffPermission:ProgressReportsAvailability",
  "StaffPermission:ProgressReports",
  "TeacherPortal:Attendance",
  "OverrideModuleSettings",
  "LibraryPortal:ToddleLibrary",
  "Common:AssignmentsManager",
  "TeacherPortal:StudentPortfolio",
  "TeacherPortal:FamilyProfile",
  "AdminPortal",
  "TeacherPortal",
  "Common:EnableSchoolPoliciesAndResources",
  "Common:EducatorCenterRevamp",
  "TeacherPortal:AttendanceManager",
  "TeacherPortal:ClassroomTodo",
  "StudentPortal:Todos",
  SNPv2_PERM,
  "AdminPortal:UnitsTrash",
  "AdminPortal:LesTrash",
  "AdminPortal:Circular",
  "AdminPortal:UnitPlans",
  "Common:AdminPortal",
  "AdminPortal:PlanningInsights",
  "AdminPortal:DPPlanningInsights",
  "AdminPortal:Settings",
  "TeacherPortal:Scheduler",
  "TeacherPortal:SchedulerMYP",
  "TeacherPortal:SchedulerUBD",
  "TeacherPortal:SchedulerDP",
  "TeacherPortal:PlanningInsights",
  "TeacherPortal:DPPlanningInsights",
  "TeacherPortal:UBD_Atls",
  "TeacherPortal:ScopeAndSequance",
  "Common:Continuum",
  "Common:Portfolio",
  "TeacherPortal:TeacherResources",
  "TeacherPortal:UnitLibrary",
  "TeacherPortal:LELibrary",
  "TeacherPortal:LELibraryMyp",
  "TeacherPortal:LELibraryUbd",
  "TeacherPortal:ShowOldClassSetting",
  "TeacherPortal:AssessmentEvaluation",
  "TeacherPortal:TeacherSchoolPolicies",
  "TeacherPortal:ClassSetting",
  "Common:NotificationConfiguration",
  "TeacherPortal:ManageFamilyMembers",
  "TeacherPortal:POI",
  "Common:PersonalProject",
  "Common:CommunityProject",
  "Common:ServiceAsAction",
  "Common:EEProjects",
  "Common:CASPortfolio",
  "Common:TOKEssayProjects",
  "Common:TOKExhibitionProjects",
  "Common:Group4AndCollaborativeSciences",
  "Common:ReflectiveProject",
  "Common:ServiceLearning",
  "TeacherPortal:AttendanceDashboard",
  "Common:LearnerPortfolio",
  "FeatureFlag:SubjectCenter",
  "FeatureFlag:BehaviourManagement",
  ENABLE_RNP_CONSUMPTION_IN_BEHAVIOUR,
  "FeatureFlag:EnableGlobalHeaderOnMultipleScreens",
  SCHOOL_LIBRARY_PERM,
  "TeacherPortal:EducationCenter",
  "TeacherPortal:ContentSkills",
  "TeacherPortal:ManageSchools",
  "TeacherPortal:ManageUnitPublish",
  "TeacherPortal:DPProgressReports",
  "TeacherPortal:MYPProgressReports",
  "TeacherPortal:UBDProgressReports",
  SNPv2_TEACHER_MODULE_PERM,
  "FeatureFlag:EnableGlobalHeader",
  "FeatureFlag:EnableGlobalSearchJumpToRevamp",
  "FeatureFlag:EnableGlobalSearchJumpToV2",
  "FeatureFlag:BehaviourAdminPortal",
  "AdminPortal:DPExamRegistration",
  "Common:IbECoursework",
  "AdminPortal:StaffPermissions",
  "FeatureFlag:WorkrampAcademyAnalytics",
  "AdminPortal:Gradebook",
  "AdminPortal:YearGroupManager",
  "AdminPortal:ProgressReports",
  "AdminPortal:MYPProgressReports",
  "AdminPortal:UBDProgressReports",
  "AdminPortal:DPProgressReports",
  "AdminPortal:Transcripts",
  "FeatureFlag:AdminTimetable",
  "IdentityAccess:Toddle2.0OrgCreation",
  BIN_PERM,
  TODDLE_2_O_PERMISSION,
  "FeatureFlag:ProductFruits",
  "FeatureFlag:InternalNPS",
  TODDLE_ANALYTICS_PERMISSION,
  ENGAGEMENT_ANALYTICS_PERMISSION,
  PERFORMANCE_ANALYTICS_PERMISSION,
  MODULE_USAGE_ANALYTICS_PERMISSION,
  BEHAVIOUR_ANALYTICS_PERMISSION,
  ATTENDANCE_ANALYTICS_PERMISSION,
  ENABLE_SENTRAL_PORTAL_ATTENDANCE_BUTTON,
  ENABLE_SENTRAL_PORTAL_POLICIES_AND_RESOURCES_BUTTON,
  ENABLE_SENTRAL_PORTAL_TIMETABLE_BUTTON,
  ENABLE_SENTRAL_PORTAL_WELLBEING_BUTTON,
  LEARNING_COURSE_PERM,
  ENABLE_SENTRAL_NEWSFEED_BUTTON,
  ENABLE_SENTRAL_NOTICE_BUTTON,
  ENABLE_SENTRAL_PXP_BUTTON,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.MODULES_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.UNITS_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.TASKS_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.STUDENTS_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.STAFF_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.FAMILY_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.REPORTS_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.INSIGHTS_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.CLASSES_SEARCH,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.COURSES_SEARCH,
  SCHOOL_HOMEPAGE_HIDDEN_MODULES_AND_PROJECTS,
  SCHOOL_HOMEPAGE_MODULES_AND_PROJECTS_ORDER,
  ENABLE_POWER_BI_CARDS,
];

const PRE_LOAD_ORGANIZATION_LEVEL_STUDENT_PERMISSIONS = [
  "FeatureFlag:PDFTronRevampedUI",
  "FeatureFlag:EnableGlobalMenuTray",
  "FeatureFlag:IsSentrySessionReplayEnabled",
  "FeatureFlag:ValentineMessage",
  "FeatureFlag:StudentArchivedClasses",
  "Common:ChangeLanguage",
  "ShowArchivedClasses",
  "StudentPortal:GlobalSearchBar",
  "FeatureFlag:StudentAnnouncementTab",
  "FeatureFlag:ShowAllYearGroupProjectGroups",
  "FeatureFlag:ShowHomeScreenWidgets",
  "FeatureFlag:DpShowHomeScreenWidgets",
  "FeatureFlag:WeightedAttendanceCategories",
  "Common:ShowConsolidatedDeadlines",
  "Common:ShowProductUpdates",
  "FeatureFlag:AnnouncementV2",
  "FeatureFlag:EnableMeetingsTabInNotification",
  "disableSentry",
  "disableMixPanel",
  "disableIntercom",
  "disableAbly",
  "disableGoogleAnalytics",
  "disableUpVoty",
  "FeatureFlag:showTheatreModeV2",
  "SpawnSingleAblyConnection",
  "FeatureFlag:ShowNotificationInGlobalTray",
  "FeatureFlag:EnableSprinklrChatSupportStudent",
  "FeatureFlag:AcademicYearSwitcher",
  ENABLE_CALENDAR_REVAMP_PHASE_1,
  SHOW_COURSE_DISPLAY_NAME,
];

const PRE_LOAD_CURRICULUM_LEVEL_STUDENT_PERMISSIONS = [
  "Common:Classroom",
  "Common:StudentGoals",
  "StudentPortal:StudentProfileV2",
  "FeatureFlag:MasterCalendarV1",
  "FeatureFlag:FeedbackForm",
  "Common:StudentAttendanceSummary",
  "Common:EnableStudentTimeTable",
  "FeatureFlag:AdminTimetable",
  "Common:PlatformCalendar",
  "Common:StudentProgressReport",
  "Common:Announcement",
  "FeatureFlag:CalendarGlobalHeaderRevampEnabled",
  "Common:StudentGradebook",
];

const PRE_LOAD_ORGANIZATION_LEVEL_FAMILY_PERMISSIONS = [
  "Common:ChangeLanguage",
  "FeatureFlag:IsSentrySessionReplayEnabled",
  "FeatureFlag:StudentArchivedClasses",
  "FeatureFlag:PDFTronRevampedUI",
  "FeatureFlag:EnableGlobalMenuTray",
  "FeatureFlag:FamilyCurriculumSwitcher",
  "FeatureFlag:ShowAllYearGroupProjectGroups",
  "FeatureFlag:WeightedAttendanceCategories",
  "Common:ShowProductUpdates",
  "FeatureFlag:AnnouncementV2",
  "FeatureFlag:StudentAnnouncementTab",
  "FeatureFlag:AcademicYearSwitcher",
  "FeatureFlag:ShowHomeScreenWidgets",
  "FeatureFlag:DpShowHomeScreenWidgets",
  "disableSentry",
  "disableMixPanel",
  "disableIntercom",
  "disableAbly",
  "disableGoogleAnalytics",
  "disableUpVoty",
  "FeatureFlag:showTheatreModeV2",
  "Common:ShowConsolidatedDeadlines",
  "FamilyPortal:FamilyProfile",
  "Common:PersonalProjectFamily",
  "Common:CommunityProjectFamily",
  "Common:ServiceAsActionFamily",
  "Common:EEProjectsFamily",
  "Common:CASPortfolioFamily",
  "Common:TOKEssayProjectsFamily",
  "Common:TOKExhibitionProjectsFamily",
  "Common:Group4AndCollaborativeSciencesFamily",
  "Common:ReflectiveProjectFamily",
  "Common:ServiceLearningFamily",
  "FeatureFlag:OneProjectFamilySetting",
  "SpawnSingleAblyConnection",
  "FeatureFlag:ShowNotificationInGlobalTray",
  "FeatureFlag:EnableSprinklrChatSupportParent",
  "FeatureFlag:MessagingV2",
  "Common:StudentNameOrder",
  "FamilyApp:Announcement",
  "FeatureFlag:AdmissionsPOC",
  ENABLE_CALENDAR_REVAMP_PHASE_1,
  SHOW_COURSE_DISPLAY_NAME,
];

const PRE_LOAD_PARENT_CURRICULUM_LEVEL_FAMILY_PERMISSIONS = [
  "Common:StudentAttendanceSummary",
  "FeatureFlag:AdminTimetable",
  "Common:Classroom",
  "Common:EnableCoursesForFamily",
  "Common:Announcement",
  "FamilyApp:Announcement",
  "Common:PlatformCalendar",
  "FeatureFlag:EnableFamilyCalendar",
  "FeatureFlag:EnableFamilyCalendar",
  "Common:FamilyCommunications",
  "FamilyApp:ProgressReport",
  "FamilyApp:SchoolPolicies",
  "Common:EnableStudentTimeTable",
  "FamilyPortal:StudentProfile",
  "FeatureFlag:CalendarGlobalHeaderRevampEnabled",
  "Common:StudentGradebook",
];

const PRE_LOAD_CURRICULUM_LEVEL_FAMILY_PERMISSIONS = [
  "FeatureFlag:EnableMeetingsTabInNotification",
];

export const PRE_LOAD_CONFIGURATIONS = {
  [STAFF]: {
    ORGANIZATION_LEVEL: PRE_LOAD_ORGANIZATION_LEVEL_STAFF_PERMISSIONS,
    CURRICULUM_LEVEL: PRE_LOAD_CURRICULUM_LEVEL_STAFF_PERMISSIONS,
  },
  [STUDENT]: {
    ORGANIZATION_LEVEL: PRE_LOAD_ORGANIZATION_LEVEL_STUDENT_PERMISSIONS,
    CURRICULUM_LEVEL: PRE_LOAD_CURRICULUM_LEVEL_STUDENT_PERMISSIONS,
  },
  [PARENT]: {
    ORGANIZATION_LEVEL: PRE_LOAD_ORGANIZATION_LEVEL_FAMILY_PERMISSIONS,
    CURRICULUM_LEVEL: PRE_LOAD_CURRICULUM_LEVEL_FAMILY_PERMISSIONS,
    PARENT_CURRICULUM_LEVEL: PRE_LOAD_PARENT_CURRICULUM_LEVEL_FAMILY_PERMISSIONS,
  },
  [ROLE_VISITOR]: {
    ORGANIZATION_LEVEL: PRE_LOAD_VISITOR_PERMISSIONS,
  },
};

export const UNIT_FLOW_REVAMP_PERMISSION = "FeatureFlag:UnitFlowRevamp";

export const UNIT_PLAN_MORE_DETAILS_IN_BANNER_PERMISSION =
  "FeatureFlag:ShowMoreDetailsInUnitPlanBanner";
export const UNIT_PLAN_AI_PERMISSION = "FeatureFlag:UnitPlanAI";
export const DATASET_V2_PERMISSION = "AdminPortal:DatasetsV2";
export const MOVE_LEARNING_GOALS_TO_DATASET =
  "FeatureFlag:MoveLearningGoalsToDataset";
export const MERGE_CUSTOM_DATASETS_INTO_LEARNING_GOALS =
  "FeatureFlag:MergeCustomDatasetsIntoLearningGoals";

export const TODDLE_PLAY_PERMISSION = "FeatureFlag:EnableToddlePlayUi";
export const OPEN_AND_CREATE_ASSIGNMENTS_IN_EDIT_MODE =
  "FeatureFlag:CreateAssignmentInEditMode";

export const ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION =
  "FeatureFlag:EnableMYPPhaseSelectionRecommendation";

export const ENABLE_GRADE_WISE_REFLECTION_QUESTIONS =
  "FeatureFlag:EnableGradeWiseReflectionQuestions";

export const SHOW_SUGGESTED_EVIDENCE_CREATOR_NAME =
  "ShowSuggestedEvidenceCreatoreName";

export const ENABLE_ACTIVITY_LOGGING = "FeatureFlag:EnableActivityLogging";

export const ACTIVITY_LOG_PERMISSION = "Module:ActivityLog";

export const ENABLE_USER_IMPERSONATION = "FeatureFlag:UserImpersonation";

export const ENABLE_STUDENT_IMPERSONATION = "FeatureFlag:StudentImpersonation";

export const ENABLE_FAMILY_INVITE_FLOW_V2 = "FeatureFlag:FamilyInviteFlowV2";

export const ENABLE_FAMILY_INVITE_PDF_V2 =
  "FeatureFlag:EnableFamilyInvitePdfV2";

export const ATTENDANCE_DASHBOARD_ACCESS_PERMISSION =
  "Module:AttendanceDashboard";

export const HOMEROOM_ACCESS_PERMISSION = "Module:Homeroom";

export const ATTENDANCE_DASHBOARD_MARK_ATTENDANCE_FOR_STUDENTS_PERMISSION =
  "AttendanceDashboard:CanMarkAttendanceForStudentsClasses";

export const ATTENDANCE_DASHBOARD_MANAGE_EXCUSALS_PERMISSION =
  "AttendanceDashboard:CanManageExcusals";

export const ATTENDANCE_DASHBOARD_SEND_REMINDERS_EDIT_RESPONSIBLE_TEACHER_FOR_CLASSES_PERMISSION =
  "AttendanceDashboard:CanSendRemindersAndEditResponsibleTeacherForClasses";

export const ATTENDANCE_DASHBOARD_VIEW_HOMEROOM_WISE_ATTENDANCE_PERMISSION =
  "AttendanceDashboard:CanViewHomeroomWiseAttendance";

export const ATTENDANCE_DASHBOARD_MARK_ATTENDANCE_ON_BEHALF_OF_HOMEROOM_ADVISORS_PERMISSION =
  "AttendanceDashboard:CanMarkAttendanceOnBehalfOfHomeroomAdvisors";

export const ATTENDANCE_DASHBOARD_MARK_ATTENDANCE_FOR_PAST_DAYS_PERMISSION =
  "AttendanceDashboard:CanMarkAttendanceForDaysInPast";

export const ATTENDANCE_ACCESS_PERMISSION = "Module:Attendance";

export const ATTENDANCE_MARK_ATTENDANCE_FOR_STUDENTS_PERMISSION =
  "Attendance:CanMarkAttendanceForStudents";

export const ATTENDANCE_MARK_ATTENDANCE_FOR_PAST_DAYS_PERMISSION =
  "Attendance:CanMarkAttendanceForDaysInPast";

export const EXCUSAL_CAN_MARK_ATTENDANCE_FOR_EXCUSALS =
  "Module:AttendanceExcusals";

export const TIMETABLE_MANAGER_ACCESS_PERMISSION = "Module:TimetableManager";

export const MANAGE_TIMETABLE_MANAGER_PERMISSION =
  "TimetableManager:CanManageTimetables";

export const VIEW_AND_MANAGE_NOTIFICATIONS = "Module:NotificationManager";
export const MANAGE_SCHOOL_ROSTER_PERMISSION =
  "SchoolRoster:CanManageSchoolRoster";
export const SCHOOL_ROSTER_RESET_FAMILY_INVITE_AND_STUDENT_CODE_PERMISSION =
  "SchoolRoster:CanResetStudentSignInAndFamilyInviteCodes";
export const SCHOOL_ROSTER_VIEW_FAMILY_INVITE_AND_STUDENT_CODE_PERMISSION =
  "SchoolRoster:CanViewStudentSignInAndFamilyInviteCode";

export const CAN_CONFIGURE_SCHOOL_OVERVIEW =
  "SchoolOverview:CanConfigureSchoolOverview";

export const MANAGE_SCHOOL_ROSTER_PERMISSION_FOR_ACCOUNT =
  "SchoolRoster:CanManageSchoolRosterForAccount";

export const SCHOOL_ROSTER_RESET_FAMILY_INVITE_AND_STUDENT_CODE_PERMISSION_FOR_ACCOUNT =
  "SchoolRoster:CanResetStudentSignInAndFamilyInviteCodesForAccount";

export const SCHOOL_ROSTER_VIEW_FAMILY_INVITE_AND_STUDENT_CODE_PERMISSION_FOR_ACCOUNT =
  "SchoolRoster:CanViewStudentSignInAndFamilyInviteCodeForAccount";

export const CAN_ADD_SUPER_ADMINS_FOR_ACCOUNT =
  "SchoolRoster:CanManageSuperAdminsForAccount";

export const MANAGE_CLASS_SETTINGS_PERMISSION =
  "ClassSettings:CanManageOtherClassSettings";

export const ASSIGN_CONTENT_TO_STUDENTS_IN_CLASS_SETTINGS_PERMISSION =
  "ClassSettings:CanBulkAssignContentToStudents";

export const MANAGE_CLASS_SETTINGS_STAFF_PERMISSION =
  "ClassSettings:CanManageStaffMembers";

export const MANAGE_CLASS_SETTINGS_STUDENT_PERMISSION =
  "ClassSettings:CanManageStudents";

export const MANAGE_SIGNIN_CODES_AND_LOGOUT_STUDENTS =
  "ClassSettings:CanManageSignInCodesAccessAndLogStudentsOut";
export const VIEW_DOWNLOAD_STUDENT_AND_FAMILY_INVITE_PERMISSION =
  "ClassSettings:CanViewDownloadStudentSignInAndFamilyInviteCode";
export const MANAGE_CLASS_SETTINGS_ICON = "ClassSettings:CanManageClassIcon";

export const MANAGE_SUBJECT_SETTINGS_GRADING_VISIBILITY_PERMISSION =
  "SubjectSettings:CanManageGradingVisibility";
export const MANAGE_SUBJECT_SETTINGS_GRADING_CONFIG_PERMISSION =
  "SubjectSettings:CanConfigureCalculateSetup";
export const MANAGE_GRADE_BOUNDARIES_PERMISSION =
  "SubjectSettings:CanConfigureGradeBoundaries";

export const MANAGE_MYP_CRITERIA_PHASE_SELECTION_PERMISSION =
  "SubjectSettings:CanConfigureMYPCriteria";

export const MANAGE_ASSESSMENT_CATEGORY_PERMISSION =
  "SubjectSettings:CanConfigureGradingCategories";

export const CLASS_SETTINGS_ACCESS_PERMISSION = "Module:ClassSettings";
export const SUBJECT_SETTINGS_ACCESS_PERMISSION = "Module:SubjectSettings";

export const ASSIGNMENTS_ACCESS_PERMISSION = "Module:Assignments";
export const ASSIGNMENTS_MANAGE_PERMISSION =
  "Assignments:CanCreateAndManageAssignments";
export const ASSIGNMENTS_ADD_RESPONSE_ON_BEHALF_OF_STUDENTS_PERMISSION =
  "Assignments:CanAddResponseOnBehalfOfStudents";
export const LIST_AND_ACCESS_ALL_PROGRAMMES_HOMEPAGE_PERMISSION =
  "Module:Programmes";
export const ASSIGNMENTS_MANAGE_PERMISSION_IN_CALENDAR =
  "Calendar:CanCreateAssignmentsInCalendar";

export const ENABLE_UNIT_PLAN_PERMISSION = "Module:UnitPlanning";
export const UNIT_PLAN_EDIT_PERMISSION = "UnitPlanning:CanManageUnitPlans";
export const UNIT_PLAN_ADMIN_PERMISSION =
  "Units:CanViewAndManageProgrammeUnitPlans";

export const CLASS_RECYCLE_BIN_ACCESS_PERMISSION = "Module:RecycleBin";

export const CAN_VIEW_STUDENT_GOALS = "Module:StudentGoals";
export const CAN_MANAGE_STUDENT_GOALS = "StudentGoals:CanCreateGoals";

export const CAN_VIEW_AND_MANAGE_ALL_PROJECT_GROUP_TYPES =
  "Module:ProjectsStudentProjects";

export const CAN_VIEW_AND_MANAGE_STUDENT_PROJECTS = "Module:ProjectsProgramme";

export const CAN_VIEW_IA_EA_MODULE = "Module:Iaea";

export const CAN_VIEW_STUDENT_PROFILE = "Module:StudentProfile";

export const CAN_VIEW_BEHAVIOUR_TAB_FOR_ALL_STUDENTS_PROGRAMME =
  "BehaviourDashboardV2ForProgramme:CanViewStudentProfileAndBehaviourForAllStudents";

export const SHARE_SCHOOL_POLICIES_AND_RESOURCES_WITH_ALL_USERS_PERMISSION =
  "SchoolPoliciesAndResources:CanShareResourcesAndPoliciesWithAllUsers";

export const VIEW_SCHOOL_POLICIES_AND_RESOURCES_MODULE_PERMISSION =
  "Module:SchoolPoliciesAndResources";

export const CAN_VIEW_PORTFOLIO_POSTS_FOR_CLASSES = "Module:Portfolio";

export const CAN_MANAGE_PORTFOLIO_POSTS_FOR_CLASSES =
  "Portfolio:CanCreateAndManagePortfolioPostsOfTheirClasses";

export const CAN_VIEW_ROUTINE_POSTS_FOR_CLASSES = "Module:Routines";

export const CAN_MANAGE_ROUTINE_POSTS_FOR_CLASSES =
  "Routines:CanCreateAndManageRoutinesOfTheirClasses";

export const ACADEMIC_SETUP_VIEW_PERM = "Module:AcademicSetup";

export const CLD3_CAN_MANAGE_CALENDAR_EVENT_TYPES_ACCOUNT_LEVEL_PERMISSION =
  "Calendar:CanManageEventTypes";
export const CLD4_CAN_MANAGE_CALENDAR_HOLIDAY_EVENTS_ACCOUNT_LEVEL_PERMISSION =
  "Calendar:CanManageHolidaysAndEvents";

export const CAN_VIEW_CALENDAR_MODULE_SETTING = "Module:Calendar";
export const CAN_MANAGE_CALENDAR_EVENTS_AND_MEETINGS_PERMISSION =
  "Calendar:CanManageCalendarEventsAndMeetings";

export const CLDC1_CAN_MANAGE_CALENDAR_CLASS_LEVEL_PERMISSION =
  "Calendar:CanCreateAssignmentsInCalendar";

export const CLASS_PLANNER_PERMISSION = "Module:WeeklyPlanners";
export const CLASS_PLANNER_EDIT_PERMISSION =
  "WeeklyPlanners:CanManageWeeklyPlanners";
export const CLASS_PLANNER_ADMIN_PERMISSION =
  "WeeklyPlanners:CanViewAndManageWeeklyPlannersForProgramme";

export const WEEKLY_SCHEDULER_PERMISSION = "Module:WeeklyPlanning";

export const PSOW_ROEP_ACCESS_PERMISSION = "Module:Psow";
export const PSOW_ROEP_MANAGE_PERMISSION = "Psow:CanManageActivities";

export const INTEGRATIONS_VIEW_AND_MANAGE_PERM =
  "Module:IntegrationsManageSync";

export const INTEGRATIONS_PROGRAMME_LEVEL_VIEW_AND_MANAGE_PERM =
  "Module:IntegrationForProgramme";

export const LIST_AND_ACCESS_ALL_CLASSES_PERMISSION =
  "Classes:CanListAndAccessAllClasses";

export const ADMIN_GRADEBOOK_ACCESS_PERMISSION = "Module:GradebookDownload";
export const COURSE_GRADEBOOK_ACCESS_PERMISSION =
  "Module:LearningGoalsAndAssessmentGradebook";
export const MANAGE_GRADEBOOK_PERMISSION = "Gradebook:CanManageGradebook";
export const STUDENT_GRADEBOOK_PERMISSION = "Common:StudentGradebook";

export const RNP_ACCOUNT_LEVEL_LABEL_PREFERENCE = "RnPAccountLevelLabelSetting";

export const RNP_PROGRAMME_LEVEL_LABEL_PREFERENCE =
  "RnPProgramLevelLabelSetting";

export const ALLOW_CLASS_EXCLUSION_WHEN_EXCLUDING_COURSE =
  "Permission:AllowClassExclusionWhenExcludingCourse";

export const RNP_LEARNING_COURSE_LEVEL_LABEL_PREFERENCE =
  "RnPLearningCourseLevelLabelSetting";

export const RNP_CLASS_LEVEL_LABEL_PREFERENCE = "RnPClassLevelLabelSetting";

export const CAN_IMPERSONATE_STAFF_PERMISSION =
  "SchoolRoster:CanImpersonateStaffMembers";

export const CAN_IMPERSONATE_STUDENT_PERMISSION =
  "SchoolRoster:CanImpersonateStudents";

export const CAN_IMPERSONATE_STUDENT_CLASS_SETTINGS_PERMISSION =
  "ClassSettings:ImpersonateStudents";

export const CAN_LOGOUT_STAFF_PERMISSION =
  "SchoolRoster:CanLogoutStaffFromAllDevices";

export const ATTENDANCE_SETTINGS_ACCESS_PERMISSION = "Module:AttendanceSetup";

export const ATTENDANCE_SETUP_FOR_ACCOUNT_ACCESS_PERMISSION =
  "Module:AttendanceSetupForAccount";

export const ATTENDANCE_SETUP_FOR_SCHOOL_ACCESS_PERMISSION =
  "Module:AttendanceSetupForSchool";

export const ATTENDANCE_SETTINGS_V2_ACCESS_PERMISSION =
  "Module:AttendanceSetupV2";

export const ATTENDANCE_SETTINGS_MANAGE_PERMISSION =
  "AttendanceSetup:CanManageAttendanceConfigurations";

export const ATTENDANCE_SETTINGS_V2_MANAGE_PERMISSION =
  "AttendanceSetupV2:CanManageAttendanceConfigurations";

export const CAN_VIEW_TIMETABLE_MODULE_PERMISSION = "Module:TimeTable";

export const ENABLE_STUDENT_TIMETABLE_PERMISSION =
  "Common:EnableStudentTimeTable";

export const CAN_VIEW_TIMETABLE_CONFIGURATIONS_PERMISSION =
  "Module:TimetableSetup";

export const CAN_VIEW_ACCOUNT_TIMETABLE_CONFIGURATIONS_V2_PERMISSION =
  "Module:TimetableSetupV2ForAccount";

export const CAN_VIEW_SCHOOL_TIMETABLE_CONFIGURATIONS_V2_PERMISSION =
  "Module:TimetableSetupV2ForSchool";

export const CAN_MANAGE_TIMETABLE_CONFIGURATIONS_PERMISSION =
  "TimetableSetup:CanManageTimetableConfigurations";

export const CAN_CARRY_OUT_AYT_PERMISSION =
  "AcademicYearTransition:CanCarryOutAcademicYearTransitionForAccount";

export const CAN_CONFIGURE_LOGIN_OPTIONS = "SchoolOverview:CanManageLoginPage";

export const CAN_VIEW_LOGIN_CONFIGURATION =
  "FeatureFlag:EnableLoginPageConfiguration";

// constants for acl permissions

export const CAN_VIEW_ALL_PROGRAMS_HOMEPAGE_ACL_ID = "195410229595210192";
export const CAN_ACCESS_ALL_PROGRAM_CLASSES_ACL_ID = "170721814769565944";

export const ENABLE_WORKFLOWS = "FeatureFlag:EnableWorkflows";

export const ENABLE_WORKFLOWS_IN_TODDLE_2_0 =
  "FeatureFlag:EnableToddle2.0Workflows";

export const ENABLE_WORKFLOW_POC_BUTTON =
  "FeatureFlag:EnableWorkflowPOCStartButton";

export const ENABLE_PROGRAM_ROLES_FOR_INTEGRATIONS =
  "FeatureFlag:EnableProgramRolesForIntegrations";

export const ACADEMIC_YEARS_AND_GRADING_PERIODS_ACCESS_PERMISSION =
  "Module:AcademicYearsAndGradingPeriods";

export const GRADE_LEVELS_ACCESS_PERMISSION_FOR_ACCOUNT =
  "Module:GradeLevelsForAccount";

export const GRADE_LEVELS_ACCESS_PERMISSION_FOR_PROGRAMME =
  "Module:GradeLevelsForProgramme";

export const USER_NAME_SETTINGS_ACCESS_PERMISSION = "Module:UserNameSettings";

export const GRADING_PERIODS_ACCESS_PERMISSION = "Module:GradingPeriods";

export const GLOBAL_MODULE_SETTINGS_ACCESS_PERMISSION_FOR_ACCOUNT =
  "Module:GlobalModuleSettingsForAccount";

export const COURSE_AND_CLASS_MODULE_SETTINGS_ACCESS_PERMISSION_FOR_ACCOUNT =
  "Module:CourseAndClassModuleSettingsForAccount";

export const MODULE_SETTINGS_ACCESS_PERMISSION_FOR_PROGRAMME =
  "Module:ModuleSettingsForProgramme";

export const GLOBAL_MODULE_SETTINGS_ACCESS_PERMISSION_FOR_PROGRAMME =
  "Module:GlobalModuleSettingsForProgramme";

export const COURSE_AND_CLASS_MODULE_SETTINGS_ACCESS_PERMISSION_FOR_PROGRAMME =
  "Module:CourseAndClassModuleSettingsForProgramme";

export const OTHER_SETTINGS_ACCESS_PERMISSION_FOR_PROGRAMME =
  "Module:OtherSettings";

export const COURSE_MANAGEMENT_ACCESS_PERMISSION_FOR_PROGRAMME =
  "Module:CourseManagementForProgramme";

export const CLASS_MANAGEMENT_ACCESS_PERMISSION_FOR_PROGRAMME =
  "Module:ClassManagementForProgramme";

export const MANAGE_CLASS_ROSTER_PERMISSION =
  "ClassManagementForProgramme:CanEditClasses";

export const MODULE_SETTINGS_GRADING_SETUP = "Module:GradingSetup";

export const ENABLE_STUDENT_STAFF_CREATION_REVAMP =
  "FeatureFlag:StudentStaffCreationRevamp";

export const ENABLE_FORMATTED_NAME_IN_CONTACT_INFO =
  "UseFormattedParentNameForContactInfo";
export const ENABLE_MIDDLE_NAME_IN_CONTACT_INFO =
  "EnableMiddleNameInContactInfo";
export const ENABLE_SECOND_NUMBER_IN_CONTACT_INFO =
  "EnableSecondNumberInContactInfo";
export const ENABLE_THIRD_NUMBER_IN_CONTACT_INFO =
  "EnableThirdNumberInContactInfo";

export const IS_SENTRAL_ESF_ORG = "FeatureFlag:isSentralESFOrg";
export const IS_ESF_MASTER_CLASS = "FeatureFlag:EnableESFMasterClass";
export const ENABLE_SENTRAL_URL_OPEN_IN_NEW_TAB =
  "FeatureFlag:OpenSentralPortalUrlInNewTab";

export const CAN_CREATE_COURSES_ON_HOMEPAGE = "Courses:CanCreateCourses";
export const CAN_CREATE_BLUEPRINT_ON_HOMEPAGE =
  "Courses:CanCreateBlueprintCourses";

export const CAN_CREATE_CLASSES_ON_HOMEPAGE = "Classes:CanCreateClasses";

export const CAN_CONFIGURE_LEARNING_GOALS_AND_UNITS_IN_REPORTS =
  "ProgressReports:CanConfigureLearningGoalsAndUnitsInReports";

export const ENABLE_PRONOUNS_IN_SCHOOL_SETUP =
  "FeatureFlag:EnableStudentPronounsInSchoolSetup";

export const ENABLE_BULK_ACTIONS = "FeatureFlag:BulkActions";

export const ENABLE_THIRD_PARTY_REDIRECT_URL_CARD =
  "FeatureFlag:EnableThirdPartyRedirectUrl";

export const ENABLE_LEVEL_CONSUMPTION = "EnableLevelConsumption";

export const ALLOW_CHANGING_STUDENT_CURRICULUM =
  "FeatureFlag:AllowChangingStudentsCurriculum";

export const BLUEPRINT_COURSE_REVAMP = "FeatureFlag:BlueprintCourseRevamp";

export const ENABLE_SENTRAL_NOTIFICATION =
  "FeatureFlag:EnableSentralNotifAndWebhook";

export const DISABLE_FAMILY_INVITE_OPTIONS =
  "FeatureFlag:DisableFamilyInviteOptions";

export const COURSE_FEED_FILTERS_PREFERENCE = "CourseFeedFiltersPreference";

export const ENABLE_STANDARDS_V2 = "AdminPortal:StandardsV2";

export const DATA_SET_COLUMNS_SETTING = "DataSetColumns";

export const ENABLE_NEW_TAGGING_MODAL = "FeatureFlag:EnableNewTaggingModal";

export const ENABLE_PARENT_STANDARDS_TAGGING =
  "FeatureFlag:EnableParentStandardsTagging";

export const ENABLE_PARENT_ATLS_TAGGING = "FeatureFlag:EnableParentATLsTagging";

export const ENABLE_PARENT_DATASETS_TAGGING =
  "FeatureFlag:EnableParentDatasetsTagging";

export const ENABLE_ENROL_WITHDRAWAL_DATE =
  "FeatureFlag:EnableEnrolWithdrawalDate";

export const ENABLE_INCIDENT_NOTIFICATION_TOGGLE =
  "Behaviour:NotifToggleInIncidentSharing";

export const CAN_VIEW_ALL_COURSES_ON_HOMEPAGE = "Courses:CanViewCourses";

export const TEACHER_COURSE_MANAGEMENT_PERM_ON_PROGRAMME =
  "CourseManagementForProgramme:CanManageCourses";

export const BLUEPRINT_COURSE_MANAGEMENT_PERM_ON_PROGRAMME =
  "CourseManagementForProgramme:CanManageBlueprintCourses";

export const ENABLE_PROGRAMME_RESTRICTION_FOR_STAFF =
  "FeatureFlag:EnableProgrammeRestrictionForStaff";

export const ENABLE_ATTENDANCE_TIERS = "FeatureFlag:AttendanceTiers";

export const ENABLE_MULTI_LE_IMPORT = "FeatureFlag:EnableMultiLEImport";

export const ENABLE_COURSE_CODE_SHEET = "FeatureFlag:EnableCourseCodeSheet";

export const CLASS_FEED_FILTERS_PREFERENCE = "ClassFeedFiltersPreference";

export const ENABLE_ATTENDANCE_2_0 = "FeatureFlag:Toddle2.0Attendance";

export const ENABLE_MANUAL_SYNC = "FeatureFlag:AnalyticsManualSync";

export const STUDENT_PROFILE_PICTURE_UPDATE_PERMISSION =
  "StudentProfile:CanUpdateStudentsProfilePhoto";

export const STAFF_PROFILE_PICTURE_UPDATE_PERMISSION =
  "StaffProfile:CanUpdateProfilePhoto";

export const CURRICULUM_INSIGHTS_PERMISSION = "Common:CurriculumInsights";

export const BULK_UPLOAD_FAMILY_GET_ROSTERED =
  "FeatureFlag:BulkUploadFamilyGetRostered";

export const ENABLE_LAST_SYNC_TIMESTAMP = "FeatureFlag:AnalyticsLastSync";

export const PRODUCT_UPDATES_CALLOUT_SETTING =
  "NewProductUpdatesCalloutPopoverViewCount";

export const ENABLE_ACCOUNT_LEVEL_DEPARTMENT =
  "FeatureFlag:EnableAccountDepartment";

export const ENABLE_WEEKLY_PLANNER_COPY_CONTENT_TO_DATE_RANGE =
  "FeatureFlag:WeeklyPlannerCopyContentToDateRange";

export const ENABLE_CONTEXTUAL_HELP = "FeatureFlag:ContextualHelp";

export const ENABLE_IDP_INIT_FLOW_USING_SAML =
  "FeatureFlag:EnableIdpInitFlowUsingSaml";

export const ENABLE_USAGE_OVERVIEW = "Analytics:EnableUsageOverview";

export const ENABLE_STUDENT_EXTERNAL_ASSESSMENTS =
  "FeatureFlag:StudentExternalAssessments";
export const CAN_UPDATE_QR_VALUE_FOR_SERVICES =
  "FeatureFlag:CanUpdateQRValueForServices";

export const ENABLE_BULK_ACTION_POLLING_CANCELLATION =
  "FeatureFlag:ShowCancelButtonForBulkAction";

export const ENABLE_ACADEMIC_PROGRAM_CONSUMPTION =
  "FeatureFlag:EnableAcademicProgramConsumption";

export const ENABLE_BULK_UPLOAD_TEMPLATE_DOWNLOAD_TEMPORAL =
  "FeatureFlag:BulkUploadTemplateDownloadTemporal";

export const ENABLE_REACT_PLAYER_VIDEO_MODALITY =
  "FeatureFlag:EnableReactPlayerVideoModality";

export const SUBMISSION_INSIGHTS_VIEW_PREFERENCE =
  "AssignmentSubmissionInsights";

export const ENABLE_EXTERNAL_FILE_EDIT = "FeatureFlag:EnableExternalFileEdit";

export const ASSESSMENT_COMMON_PREFERENCE = "AssessmentCommonPreferences";

export const SECURE_CODE_UPGRADE_PERM = "FeatureFlag:SecureCodeUpgrade";

export const IS_MFA_ENABLED = "FeatureFlag:MfaEnabled";

export const ENABLE_SUBMISSION_STATUS_OVERRIDE =
  "FeatureFlag:EnableSubmissionStatusOverride";

export const ENABLE_QUICK_COPY_UPDATE = "FeatureFlag:QuickCopyUpdate";

export const ENABLE_ASSIGNMENTS_UNIT_TAGGING_IN_2_0 =
  "FeatureFlag:AllowAssignmentsUnitTaggingIn2.0";

export const ENABLE_STUDENT_TRANSFER = "FeatureFlag:EnableStudentTransfer";

export const ENABLE_BIG_ORG_CHANGES_IN_RNP =
  "FeatureFlag:EnableBigOrgChangesInRnP";

export const STUDENT_DATA_SHARING_PREFERENCE = "StudentDataSharingPreference";

export const ACCOUNT_LEVEL_GRADING_PERIODS_PERMISSION =
  "FeatureFlag:AccountLevelGradingPeriods";
